/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EngineeringFeature;
(function (EngineeringFeature) {
    var type;
    (function (type) {
        type["IMPLIED"] = "Implied";
        type["DERIVED"] = "Derived";
        type["BASE"] = "Base";
        type["NON_BASE"] = "NonBase";
    })(type = EngineeringFeature.type || (EngineeringFeature.type = {}));
})(EngineeringFeature || (EngineeringFeature = {}));
